"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Link_exports = {};
__export(Link_exports, {
  default: () => Link_default
});
module.exports = __toCommonJS(Link_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.3165 5.58428C12.6333 6.12189 12.0662 7.08573 11.4216 8.20222C11.2559 8.4892 10.8889 8.58752 10.602 8.42184C10.315 8.25615 10.2167 7.8892 10.3824 7.60222C10.3948 7.58061 10.4073 7.55893 10.4199 7.53719C11.016 6.50434 11.6893 5.33777 12.5744 4.64124C13.0462 4.27003 13.6006 4.0114 14.2523 3.97782C14.8995 3.94448 15.5792 4.13633 16.3 4.55248C17.0208 4.96863 17.5269 5.46139 17.8216 6.03854C18.1184 6.61973 18.1716 7.22917 18.086 7.82332C17.9254 8.93817 17.2517 10.1045 16.6553 11.1372C16.6427 11.1589 16.6302 11.1806 16.6177 11.2022L16.6097 11.2161C16.3031 11.7471 15.9954 12.2802 15.6703 12.745C15.3427 13.2134 14.9726 13.6497 14.5257 13.9653C14.0661 14.2898 13.5325 14.481 12.9094 14.4618C12.3001 14.443 11.653 14.2248 10.95 13.819C10.6631 13.6533 10.5647 13.2863 10.7304 12.9993C10.8961 12.7124 11.2631 12.614 11.55 12.7797C12.1461 13.1239 12.5983 13.2516 12.9463 13.2623C13.2805 13.2726 13.5622 13.1767 13.8335 12.985C14.1176 12.7845 14.3943 12.4756 14.6869 12.0572C14.9793 11.6392 15.2628 11.1491 15.5785 10.6022C16.2231 9.48573 16.7743 8.51269 16.8982 7.6522C16.9566 7.24695 16.9133 6.89856 16.7529 6.58427C16.5903 6.26593 16.2783 5.92556 15.7 5.59171C15.1218 5.25787 14.671 5.15784 14.3141 5.17623C13.9616 5.19439 13.6383 5.3311 13.3165 5.58428ZM9.8766 11.5248C9.25473 11.9772 8.75521 12.8205 8.17159 13.8314C7.58796 14.8423 7.10741 15.6965 7.02653 16.4613C6.98909 16.8153 7.04186 17.1304 7.21235 17.4287C7.3873 17.7349 7.71306 18.07 8.30005 18.4089C8.88704 18.7478 9.34009 18.8624 9.69273 18.8608C10.0364 18.8592 10.3356 18.7474 10.6235 18.538C11.2454 18.0855 11.7449 17.2423 12.3285 16.2314C12.4942 15.9444 12.8611 15.8461 13.1481 16.0118C13.4351 16.1775 13.5334 16.5444 13.3677 16.8314C13.3549 16.8537 13.342 16.876 13.329 16.8985C12.7965 17.8213 12.1802 18.8894 11.3295 19.5083C10.8707 19.8421 10.3313 20.0579 9.69811 20.0608C9.07395 20.0636 8.41209 19.8592 7.70005 19.4481C6.988 19.037 6.4801 18.566 6.17044 18.0241C5.85631 17.4743 5.77351 16.8992 5.83318 16.335C5.94384 15.2888 6.56068 14.221 7.09363 13.2984C7.10659 13.276 7.1195 13.2537 7.13236 13.2314C7.14521 13.2091 7.15811 13.1868 7.17106 13.1643C7.70357 12.2415 8.3199 11.1734 9.17062 10.5544C9.62938 10.2207 10.1688 10.0048 10.802 10.002C11.4261 9.99921 12.088 10.2036 12.8 10.6147C13.087 10.7803 13.1853 11.1473 13.0197 11.4343C12.854 11.7212 12.487 11.8196 12.2 11.6539C11.6131 11.315 11.16 11.2004 10.8074 11.202C10.4637 11.2035 10.1645 11.3154 9.8766 11.5248Z",
      fill: "currentColor"
    }
  )
);
const SvgLink = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Link_default = SvgLink;
